import $ from 'jquery'

const renderTag = (label,val) => `
  <div class="cur-tag" val="${val}">
    ${label}
    <i class="ri-close-fill ms-2" tag-close></i>
  </div>
`

const activateBtn = () => {
  const btn = $('[cm-select-btn]')
  if(btn.length > 0) {
    btn.removeAttr('disabled')
  }
}

$('[cm-select-btn]').attr('disabled','true')

$(`[tag-close]`).click((e) => {
  e.stopImmediatePropagation()
  const { currentTarget:closeEl } = e
  const select = $(closeEl).parents('.cm-select')
  const cur = select.find('.cm-select__cur')
  const delVal = $(closeEl).parents('.cur-tag').attr('val')
  const listItem = $(select).find(`.dropdown-item[val='${delVal}']`)
  let val = select.attr('data-value').split(',').filter(item => item !== delVal)
  select.attr('data-value',val)
  listItem.removeClass('active')
  $(`.cur-tag[val='${delVal}']`).remove()
  if(val.length === 0) {
    cur.removeClass('has-tag')
  }
  activateBtn()
})

$("[cm-select] .cm-select__trigger").click((e) => {
  const { currentTarget:el } = e
  const select = $(el).parents('.cm-select')
  if($(select).hasClass('active')) {
    $('.cm-select.active').removeClass('active')
  } else {
    $('.cm-select.active').removeClass('active')
    select.addClass('active')
  }
})

$("[cm-select='single'] .cm-select__options li").click((e) => {
  const { currentTarget:el } = e
  const select = $(el).parents('.cm-select')
  const cur = select.find('.cm-select__cur')
  const val = el.getAttribute('val')
  select.attr('data-value',val)
  cur.find('label').text($(el).find('label').text())
  $(el).siblings().removeClass('active')
  $(el).addClass('active')
  $('.cm-select.active').removeClass('active')
  activateBtn()
})

$("[cm-select='multiple'] .cm-select__options li").click((e) => {
  const { currentTarget:el } = e
  const select = $(el).parents('.cm-select')
  const cur = select.find('.cm-select__cur')
  let val = select.attr('data-value').split(',').filter(item => item !== '')
  const option = el.getAttribute('val')
  if($(el).hasClass('active')) {
    val = val.filter(item => item !== option)
    $(el).removeClass('active')
    $(`.cur-tag[val='${option}']`).remove()
    if(val.length === 0) {
      cur.removeClass('has-tag')
    }
  } else {
    $(el).addClass('active')
    val.push(option)
    cur.addClass('has-tag')
    cur.append(renderTag($(el).find('label').text(),option))
    $(`[val=${option}] [tag-close]`).click((e) => {
      e.stopImmediatePropagation()
      const { currentTarget:closeEl } = e
      const delVal = $(closeEl).parents('.cur-tag').attr('val')
      let val = select.attr('data-value').split(',').filter(item => item !== delVal)
      select.attr('data-value',val)
      $(el).removeClass('active')
      $(`.cur-tag[val='${option}']`).remove()
      if(val.length === 0) {
        cur.removeClass('has-tag')
      }
    })
  }
  select.attr('data-value',val)
  activateBtn()
})

$(document).bind('click',(e) => {
  const target = $(e.target)
  if(target.closest('.cm-select').length === 0) {
    $('.cm-select').removeClass('active')
  }
})